import { useEffect, useState, type FunctionComponent } from 'react';
import { Elements, RecurlyProvider } from '@recurly/react-recurly';
import { LoadingSpinner } from '@fff-web/fff-ui-shared';
import {
  type ICardInformation,
  type IRecurlyPaymentForm,
  type IUpgradeFormOnSubmit,
  type TokenPayload,
} from '../../../interfaces';
import { getBillingInformation, updateBillingInformation } from '../../../lib/services/billing';
import { getEnv } from '../../../lib/utils/environment';
import { loadRecurly } from '../../../lib/utils/loadRecurly';
import UpgradeForm from '../UpgradeForm';
import '../../../lib/assets/recurly.css';

const RecurlyPaymentForm: FunctionComponent<IRecurlyPaymentForm> = ({ onSuccess = () => null }) => {
  const [load, setLoad] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cardInformation, setCardInformation] = useState<ICardInformation>();

  useEffect(() => {
    loadRecurly().then(() => setLoad(true));
    getBillingInformation().then((info) => {
      setCardInformation(info as ICardInformation);
    });
  }, []);

  const handleSubmit = ({ id, type }: IUpgradeFormOnSubmit) => {
    setIsSubmitting(true);
    updateBillingInformation({
      token_id: id,
      type,
    }).then((response) => {
      onSuccess(response as TokenPayload);
      setIsSubmitting(false);
    });
  };

  return !load ? (
    <LoadingSpinner />
  ) : (
    // @ts-expect-error - RecurlyProvider dep needs to be updated for this to work
    <RecurlyProvider publicKey={getEnv().recurlyPublicKey}>
      {/* @ts-expect-error - RecurlyProvider dep needs to be updated for this to work */}
      <Elements>
        <UpgradeForm
          onSubmit={handleSubmit}
          cardInformation={cardInformation}
          isDisabled={isSubmitting}
        />
      </Elements>
    </RecurlyProvider>
  );
};

export default RecurlyPaymentForm;
